import styled from 'styled-components'
import { theme } from 'styles/theme'

export const Title = styled.h1`
  margin: 8rem 0 0;
  font: 600 5rem ${theme.fonts.headings};
  text-transform: uppercase;
`
